module.exports = __webpack_public_path__ + "static/media/google-maps-challenge.00589f96.png";